var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1567)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#43BA92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 24,
    width: 75,
    height: 259,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 249,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 220,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 190,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 160,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 130,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 101,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 72,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 42,
    width: 75,
    height: 15,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 57,
    width: 34,
    height: 192,
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 71,
    width: 8,
    height: 149,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 24,
    width: 15,
    height: 259,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24,
    width: 15,
    height: 259,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 190,
    width: 33,
    height: 89,
    fill: "#5F6571"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 300,
    width: 60,
    height: 40,
    fill: "#FFFEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 309,
    width: 40,
    height: 22,
    fill: "#54B4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 14,
    height: 9,
    fill: "#344849"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 99,
    width: 14,
    height: 9,
    fill: "#344849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23H17.5V38.5H30V93H17.5V108H0V23Z",
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 125,
    width: 34,
    height: 51,
    fill: "#FDC824"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 138,
    width: 19,
    height: 25,
    fill: "#DA982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 364,
    width: 34,
    height: 68,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 371,
    width: 10,
    height: 16,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 396,
    width: 10,
    height: 28,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 405,
    width: 34,
    height: 68,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 412,
    width: 10,
    height: 16,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 437,
    width: 10,
    height: 28,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 534,
    width: 42,
    height: 78,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 536,
    width: 36,
    height: 74,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 541,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 556,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 571,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 586,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 601,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 541,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 556,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 571,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 586,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 601,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 618,
    width: 6,
    height: 4,
    transform: "rotate(-90 58 618)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 618,
    width: 6,
    height: 4,
    transform: "rotate(-90 47 618)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 618,
    width: 6,
    height: 4,
    transform: "rotate(-90 36 618)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 534,
    width: 6,
    height: 4,
    transform: "rotate(-90 58 534)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 534,
    width: 6,
    height: 4,
    transform: "rotate(-90 47 534)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 534,
    width: 6,
    height: 4,
    transform: "rotate(-90 36 534)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 30,
    width: 42,
    height: 78,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 32,
    width: 36,
    height: 74,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 37,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 52,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 67,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 82,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 97,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 37,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 52,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 67,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 82,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 97,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 114,
    width: 6,
    height: 4,
    transform: "rotate(-90 408 114)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 114,
    width: 6,
    height: 4,
    transform: "rotate(-90 397 114)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 114,
    width: 6,
    height: 4,
    transform: "rotate(-90 386 114)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 30,
    width: 6,
    height: 4,
    transform: "rotate(-90 408 30)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 30,
    width: 6,
    height: 4,
    transform: "rotate(-90 397 30)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 30,
    width: 6,
    height: 4,
    transform: "rotate(-90 386 30)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 633,
    width: 318,
    height: 31,
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 642,
    width: 318,
    height: 12,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 642,
    width: 22,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 642,
    width: 22,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 682,
    width: 318,
    height: 31,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 691,
    width: 318,
    height: 12,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 691,
    width: 22,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 691,
    width: 22,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 750,
    width: 271,
    height: 31,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 759,
    width: 271,
    height: 13,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 740,
    width: 271,
    height: 10,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 802,
    width: 271,
    height: 31,
    fill: "#FCCCA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 811,
    width: 271,
    height: 13,
    fill: "#EBAA79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 792,
    width: 271,
    height: 10,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 851,
    width: 43,
    height: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 857,
    width: 29,
    height: 15,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 851,
    width: 43,
    height: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 857,
    width: 29,
    height: 15,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 851,
    width: 43,
    height: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 857,
    width: 29,
    height: 15,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 851,
    width: 43,
    height: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 857,
    width: 29,
    height: 15,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 418,
    width: 43,
    height: 27,
    transform: "rotate(-90 1268 418)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274,
    y: 411,
    width: 29,
    height: 15,
    transform: "rotate(-90 1274 411)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 480,
    width: 43,
    height: 27,
    transform: "rotate(-90 1268 480)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274,
    y: 473,
    width: 29,
    height: 15,
    transform: "rotate(-90 1274 473)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 541,
    width: 43,
    height: 27,
    transform: "rotate(-90 1268 541)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274,
    y: 534,
    width: 29,
    height: 15,
    transform: "rotate(-90 1274 534)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 602,
    width: 43,
    height: 27,
    transform: "rotate(-90 1268 602)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1274,
    y: 595,
    width: 29,
    height: 15,
    transform: "rotate(-90 1274 595)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.711 805.289C351.054 801.632 349 796.672 349 791.5C349 786.328 351.054 781.368 354.711 777.711C358.368 774.054 363.328 772 368.5 772C373.672 772 378.632 774.054 382.289 777.711L368.5 791.5L354.711 805.289Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.289 777.711C385.946 781.368 388 786.328 388 791.5C388 796.672 385.946 801.632 382.289 805.289C378.632 808.946 373.672 811 368.5 811C363.328 811 358.368 808.946 354.711 805.289L368.5 791.5L382.289 777.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.711 667.289C423.054 663.632 421 658.672 421 653.5C421 648.328 423.054 643.368 426.711 639.711C430.368 636.054 435.328 634 440.5 634C445.672 634 450.632 636.054 454.289 639.711L440.5 653.5L426.711 667.289Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.289 639.711C457.946 643.368 460 648.328 460 653.5C460 658.672 457.946 663.632 454.289 667.289C450.632 670.946 445.672 673 440.5 673C435.328 673 430.368 670.946 426.711 667.289L440.5 653.5L454.289 639.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3934 503.607C87.5804 500.794 86 496.978 86 493C86 489.022 87.5804 485.206 90.3934 482.393C93.2064 479.58 97.0217 478 101 478C104.978 478 108.794 479.58 111.607 482.393L101 493L90.3934 503.607Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.607 482.393C114.42 485.206 116 489.022 116 493C116 496.978 114.42 500.794 111.607 503.607C108.794 506.42 104.978 508 101 508C97.0218 508 93.2064 506.42 90.3934 503.607L101 493L111.607 482.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.393 467.607C113.58 464.794 112 460.978 112 457C112 453.022 113.58 449.206 116.393 446.393C119.206 443.58 123.022 442 127 442C130.978 442 134.794 443.58 137.607 446.393L127 457L116.393 467.607Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.607 446.393C140.42 449.206 142 453.022 142 457C142 460.978 140.42 464.794 137.607 467.607C134.794 470.42 130.978 472 127 472C123.022 472 119.206 470.42 116.393 467.607L127 457L137.607 446.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.393 384.607C390.58 381.794 389 377.978 389 374C389 370.022 390.58 366.206 393.393 363.393C396.206 360.58 400.022 359 404 359C407.978 359 411.794 360.58 414.607 363.393L404 374L393.393 384.607Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.607 363.393C417.42 366.206 419 370.022 419 374C419 377.978 417.42 381.794 414.607 384.607C411.794 387.42 407.978 389 404 389C400.022 389 396.206 387.42 393.393 384.607L404 374L414.607 363.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.393 520.607C363.58 517.794 362 513.978 362 510C362 506.022 363.58 502.206 366.393 499.393C369.206 496.58 373.022 495 377 495C380.978 495 384.794 496.58 387.607 499.393L377 510L366.393 520.607Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.607 499.393C390.42 502.206 392 506.022 392 510C392 513.978 390.42 517.794 387.607 520.607C384.794 523.42 380.978 525 377 525C373.022 525 369.206 523.42 366.393 520.607L377 510L387.607 499.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.393 565.607C363.58 562.794 362 558.978 362 555C362 551.022 363.58 547.206 366.393 544.393C369.206 541.58 373.022 540 377 540C380.978 540 384.794 541.58 387.607 544.393L377 555L366.393 565.607Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.607 544.393C390.42 547.206 392 551.022 392 555C392 558.978 390.42 562.794 387.607 565.607C384.794 568.42 380.978 570 377 570C373.022 570 369.206 568.42 366.393 565.607L377 555L387.607 544.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.393 610.607C363.58 607.794 362 603.978 362 600C362 596.022 363.58 592.206 366.393 589.393C369.206 586.58 373.022 585 377 585C380.978 585 384.794 586.58 387.607 589.393L377 600L366.393 610.607Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.607 589.393C390.42 592.206 392 596.022 392 600C392 603.978 390.42 607.794 387.607 610.607C384.794 613.42 380.978 615 377 615C373.022 615 369.206 613.42 366.393 610.607L377 600L387.607 589.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.393 45.6066C240.58 42.7936 239 38.9782 239 35C239 31.0218 240.58 27.2064 243.393 24.3934C246.206 21.5804 250.022 20 254 20C257.978 20 261.794 21.5803 264.607 24.3934L254 35L243.393 45.6066Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.607 24.3934C267.42 27.2064 269 31.0218 269 35C269 38.9782 267.42 42.7936 264.607 45.6066C261.794 48.4196 257.978 50 254 50C250.022 50 246.206 48.4196 243.393 45.6066L254 35L264.607 24.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.393 45.6066C286.58 42.7936 285 38.9782 285 35C285 31.0218 286.58 27.2064 289.393 24.3934C292.206 21.5804 296.022 20 300 20C303.978 20 307.794 21.5803 310.607 24.3934L300 35L289.393 45.6066Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.607 24.3934C313.42 27.2064 315 31.0218 315 35C315 38.9782 313.42 42.7936 310.607 45.6066C307.794 48.4196 303.978 50 300 50C296.022 50 292.206 48.4196 289.393 45.6066L300 35L310.607 24.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.393 45.6066C332.58 42.7936 331 38.9782 331 35C331 31.0218 332.58 27.2064 335.393 24.3934C338.206 21.5804 342.022 20 346 20C349.978 20 353.794 21.5803 356.607 24.3934L346 35L335.393 45.6066Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.607 24.3934C359.42 27.2064 361 31.0218 361 35C361 38.9782 359.42 42.7936 356.607 45.6066C353.794 48.4196 349.978 50 346 50C342.022 50 338.206 48.4196 335.393 45.6066L346 35L356.607 24.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.393 89.6066C240.58 86.7936 239 82.9782 239 79C239 75.0218 240.58 71.2064 243.393 68.3934C246.206 65.5804 250.022 64 254 64C257.978 64 261.794 65.5803 264.607 68.3934L254 79L243.393 89.6066Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.607 68.3934C267.42 71.2064 269 75.0218 269 79C269 82.9782 267.42 86.7936 264.607 89.6066C261.794 92.4196 257.978 94 254 94C250.022 94 246.206 92.4196 243.393 89.6066L254 79L264.607 68.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.393 89.6066C286.58 86.7936 285 82.9782 285 79C285 75.0218 286.58 71.2064 289.393 68.3934C292.206 65.5804 296.022 64 300 64C303.978 64 307.794 65.5803 310.607 68.3934L300 79L289.393 89.6066Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.607 68.3934C313.42 71.2064 315 75.0218 315 79C315 82.9782 313.42 86.7936 310.607 89.6066C307.794 92.4196 303.978 94 300 94C296.022 94 292.206 92.4196 289.393 89.6066L300 79L310.607 68.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.393 89.6066C332.58 86.7936 331 82.9782 331 79C331 75.0218 332.58 71.2064 335.393 68.3934C338.206 65.5804 342.022 64 346 64C349.978 64 353.794 65.5803 356.607 68.3934L346 79L335.393 89.6066Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.607 68.3934C359.42 71.2064 361 75.0218 361 79C361 82.9782 359.42 86.7936 356.607 89.6066C353.794 92.4196 349.978 94 346 94C342.022 94 338.206 92.4196 335.393 89.6066L346 79L356.607 68.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 529,
    width: 39,
    height: 91,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 538,
    width: 23,
    height: 72,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 545,
    width: 7,
    height: 13,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 570,
    width: 7,
    height: 34,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 431,
    width: 39,
    height: 91,
    transform: "rotate(90 540 431)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531,
    y: 439,
    width: 23,
    height: 72,
    transform: "rotate(90 531 439)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524,
    y: 447,
    width: 7,
    height: 13,
    transform: "rotate(90 524 447)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499,
    y: 447,
    width: 7,
    height: 34,
    transform: "rotate(90 499 447)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 480,
    width: 47,
    height: 24,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 487,
    width: 33,
    height: 10,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1642,
    y: 453,
    width: 47,
    height: 24,
    transform: "rotate(-90 1642 453)",
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1649,
    y: 446,
    width: 33,
    height: 10,
    transform: "rotate(-90 1649 446)",
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 463,
    width: 35,
    height: 36,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 466,
    width: 29,
    height: 30,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 499,
    width: 3,
    height: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 499,
    width: 3,
    height: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 499,
    width: 3,
    height: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 458,
    width: 3,
    height: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 458,
    width: 3,
    height: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 458,
    width: 3,
    height: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 488,
    width: 5,
    height: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 479,
    width: 5,
    height: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 470,
    width: 5,
    height: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 488,
    width: 5,
    height: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 479,
    width: 5,
    height: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 470,
    width: 5,
    height: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 584,
    width: 102,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 594,
    width: 102,
    height: 16,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 594,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 594,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 594,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 594,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 594,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 594,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 594,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 529,
    width: 102,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 539,
    width: 102,
    height: 16,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 539,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 539,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 539,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 539,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 539,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 539,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 539,
    width: 6,
    height: 16,
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 470,
    width: 34,
    height: 149,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 485,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 485,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 502,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 502,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 519,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 519,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 536,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 536,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 553,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 553,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 570,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 570,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 587,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 587,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 604,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 604,
    r: 4,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 470,
    width: 34,
    height: 149,
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 485,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 485,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 502,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 502,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 519,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 519,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 536,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 536,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 553,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 553,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 570,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 570,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 587,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 587,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 604,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 604,
    r: 4,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 827,
    width: 79,
    height: 51,
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 839,
    width: 55,
    height: 26,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 717,
    width: 79,
    height: 51,
    transform: "rotate(-90 1268 717)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 706,
    width: 55,
    height: 26,
    transform: "rotate(-90 1280 706)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467,
    y: 827,
    width: 79,
    height: 51,
    fill: "#FCCCA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 839,
    width: 55,
    height: 26,
    fill: "#EBAA79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 818,
    width: 79,
    height: 51,
    transform: "rotate(-90 1268 818)",
    fill: "#FCCCA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 807,
    width: 55,
    height: 26,
    transform: "rotate(-90 1280 807)",
    fill: "#EBAA79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 472,
    width: 53,
    height: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 481,
    width: 53,
    height: 11,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 429,
    width: 53,
    height: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 438,
    width: 53,
    height: 11,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479,
    y: 635,
    width: 82,
    height: 38,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 642,
    width: 64,
    height: 24,
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 731H415L349 750V731Z",
    fill: "#8E929E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 750H349L415 731V750Z",
    fill: "#5F6573"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 703,
    width: 33,
    height: 59,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 703,
    width: 16,
    height: 59,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 528,
    width: 33,
    height: 59,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 528,
    width: 16,
    height: 59,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 615,
    width: 33,
    height: 59,
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575,
    y: 615,
    width: 16,
    height: 59,
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 762,
    width: 20,
    height: 53,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 767,
    width: 11,
    height: 42,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 772,
    width: 4,
    height: 7,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 786,
    width: 4,
    height: 20,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1331,
    y: 691,
    width: 20,
    height: 53,
    transform: "rotate(-90 1331 691)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1336,
    y: 687,
    width: 11,
    height: 42,
    transform: "rotate(-90 1336 687)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 683,
    width: 4,
    height: 7,
    transform: "rotate(-90 1341 683)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1355,
    y: 683,
    width: 4,
    height: 20,
    transform: "rotate(-90 1355 683)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 702,
    width: 94,
    height: 95,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 710,
    width: 80,
    height: 79,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 702,
    width: 6,
    height: 95,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 745,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 721,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 769,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429,
    y: 745,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429,
    y: 721,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429,
    y: 769,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 797,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 797,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461,
    y: 797,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 688,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 688,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461,
    y: 688,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 797,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 797,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 797,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 688,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 688,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 688,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 769,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 745,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 721,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 493,
    width: 126,
    height: 126,
    rx: 5,
    fill: "#5F6571"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 540,
    width: 126,
    height: 12,
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437,
    y: 508,
    width: 80,
    height: 15,
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 567,
    width: 126,
    height: 12,
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 595,
    width: 126,
    height: 12,
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.5,
    cy: 403.5,
    rx: 24.5,
    ry: 25.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.5,
    cy: 403,
    rx: 18.5,
    ry: 18,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 403.5C370 426.42 351.42 445 328.5 445C305.58 445 287 426.42 287 403.5C287 380.58 305.58 362 328.5 362C351.42 362 370 380.58 370 403.5ZM292.904 403.5C292.904 423.159 308.841 439.096 328.5 439.096C348.159 439.096 364.096 423.159 364.096 403.5C364.096 383.841 348.159 367.904 328.5 367.904C308.841 367.904 292.904 383.841 292.904 403.5Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 372H261V387.5H250V409.5V426.5H261V442H154V426.5H167V407V387.5H154V372Z",
    fill: "#5E6470"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 379,
    width: 6,
    height: 55,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 379,
    width: 6,
    height: 55,
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 379,
    width: 6,
    height: 55,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 379,
    width: 6,
    height: 55,
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 379,
    width: 6,
    height: 55,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 379,
    width: 6,
    height: 55,
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 379,
    width: 6,
    height: 55,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 379,
    width: 6,
    height: 55,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 379,
    width: 6,
    height: 55,
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 434,
    r: 3,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 379,
    r: 3,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 379,
    r: 3,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 434,
    r: 3,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 397,
    width: 27,
    height: 19,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 401,
    width: 9,
    height: 12,
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 372H154V387.5H150V372Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 426.5H154V442H150V426.5Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 416V412H167V416H129Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 401V397H167V401H128Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 283H129V416H124V283Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 291,
    width: 46,
    height: 47,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 295,
    width: 40,
    height: 39,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 291,
    width: 4,
    height: 47,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 312,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 300,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 324,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 312,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 300,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 324,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 312,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 300,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 324,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 338,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 338,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 338,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 338,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 338,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 338,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 285,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 285,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 285,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 285,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 285,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 285,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 124,
    width: 46,
    height: 47,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 128,
    width: 40,
    height: 39,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 124,
    width: 4,
    height: 47,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 145,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 133,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 157,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 145,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 133,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 157,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 145,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 133,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 157,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 171,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 171,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 171,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 171,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 171,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 171,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 118,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 118,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 118,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 118,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 118,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 118,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1617,
    y: 284,
    width: 46,
    height: 47,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 288,
    width: 40,
    height: 39,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1663,
    y: 284,
    width: 4,
    height: 47,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1663,
    y: 305,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1663,
    y: 293,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1663,
    y: 317,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1611,
    y: 305,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1611,
    y: 293,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1611,
    y: 317,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1669,
    y: 305,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1669,
    y: 293,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1669,
    y: 317,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638,
    y: 331,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1626,
    y: 331,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 331,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1642,
    y: 331,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1630,
    y: 331,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1654,
    y: 331,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638,
    y: 278,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1626,
    y: 278,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 278,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1642,
    y: 278,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1630,
    y: 278,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1654,
    y: 278,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 195,
    width: 46,
    height: 71,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 199,
    width: 40,
    height: 63,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 195,
    width: 4,
    height: 71,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 205,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 228,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 252,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 205,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 228,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 252,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 205,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 228,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 252,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 266,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 266,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 266,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 266,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 266,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 266,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 189,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 189,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 189,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 189,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 189,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 189,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 30,
    width: 46,
    height: 71,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 34,
    width: 40,
    height: 63,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 30,
    width: 4,
    height: 71,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 40,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 63,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 87,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 40,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 63,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 87,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 40,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 63,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 87,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 101,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 101,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 101,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 101,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 101,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 101,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 24,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 24,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 24,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 24,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 24,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 24,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 133,
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 139H265L247 157V139Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 157H247L265 139V157Z",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 133,
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 139H307L289 157V139Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 157H289L307 139V157Z",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 132,
    width: 96,
    height: 31,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 142,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 155,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357,
    cy: 142,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357,
    cy: 155,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 142,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 155,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 142,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 155,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 142,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 155,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 51,
    width: 35,
    height: 323,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 22,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 374,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463,
    y: 22,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463,
    y: 374,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 51,
    width: 7,
    height: 323,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 76,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 111,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 146,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 181,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 216,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 251,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 286,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 321,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 51,
    width: 35,
    height: 323,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 22,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 374,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 22,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 374,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 51,
    width: 7,
    height: 323,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 76,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 111,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 146,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 181,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 216,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 251,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 286,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 321,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543,
    y: 51,
    width: 35,
    height: 323,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549,
    y: 22,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549,
    y: 374,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571,
    y: 22,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571,
    y: 374,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578,
    y: 51,
    width: 7,
    height: 323,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 76,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 111,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 146,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 181,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 216,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 251,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 286,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 321,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 276,
    width: 71,
    height: 68,
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 180H300V196.5L314 210L300 248L272 244L255.5 260H241V180Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 254,
    width: 71,
    height: 18,
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 345,
    width: 71,
    height: 18,
    transform: "rotate(-90 314 345)",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 265H257L268.5 253.5L312 265V281L268.5 268L256 281H241V265Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 180H321V195.5L331 206.5H315L304 194V180Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5 180H406V249.5H375.5L359 228L325.5 194V180Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 286.5H257L274 268.5L310 276V344H241V286.5Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 204,
    width: 112,
    height: 118,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 231,
    width: 53,
    height: 64,
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 237H343L303 288V237Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 288H303L343 237V288Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 292,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 292,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 281,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 281,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 268,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 268,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 257,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 257,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 245,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 245,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 234,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 234,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 222,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 211,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 245,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 245,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 234,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 234,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 268,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 268,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 257,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 257,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 291,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 291,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 280,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 280,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 314,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 303,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 327,
    r: 7,
    fill: "#41BA8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 198,
    r: 7,
    fill: "#41BA8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 327,
    r: 7,
    fill: "#41BA8F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 187,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 187,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 198,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 198,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 209,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 209,
    width: 6,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.11,
    y: 870.85,
    width: 75,
    height: 259,
    transform: "rotate(-179.899 1186.11 870.85)",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.51,
    y: 645.851,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1186.51 645.851)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1185.46,
    y: 674.849,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1185.46 674.849)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.4,
    y: 704.85,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1186.4 704.85)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.35,
    y: 734.85,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1186.35 734.85)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.29,
    y: 764.85,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1186.29 764.85)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.24,
    y: 793.85,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1186.24 793.85)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.19,
    y: 822.85,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1186.19 822.85)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1186.14,
    y: 852.85,
    width: 75,
    height: 15,
    transform: "rotate(-179.899 1186.14 852.85)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1165.17,
    y: 837.813,
    width: 34,
    height: 192,
    transform: "rotate(-179.899 1165.17 837.813)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.19,
    y: 823.79,
    width: 8,
    height: 149,
    transform: "rotate(-179.899 1152.19 823.79)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1111.11,
    y: 870.718,
    width: 15,
    height: 259,
    transform: "rotate(-179.899 1111.11 870.718)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.11,
    y: 870.876,
    width: 15,
    height: 259,
    transform: "rotate(-179.899 1201.11 870.876)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1249.4,
    y: 704.961,
    width: 33,
    height: 89,
    transform: "rotate(-179.899 1249.4 704.961)",
    fill: "#5F6571"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1249.6,
    y: 594.961,
    width: 60,
    height: 40,
    transform: "rotate(-179.899 1249.6 594.961)",
    fill: "#FFFEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1239.61,
    y: 585.944,
    width: 40,
    height: 22,
    transform: "rotate(-179.899 1239.61 585.944)",
    fill: "#54B4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 256.106,
    width: 60,
    height: 40,
    transform: "rotate(-179.899 1335 256.106)",
    fill: "#FFFEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1325.02,
    y: 247.088,
    width: 40,
    height: 22,
    transform: "rotate(-179.899 1325.02 247.088)",
    fill: "#54B4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233.11,
    y: 871.933,
    width: 14,
    height: 9,
    transform: "rotate(-179.899 1233.11 871.933)",
    fill: "#344849"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233.24,
    y: 795.933,
    width: 14,
    height: 9,
    transform: "rotate(-179.899 1233.24 795.933)",
    fill: "#344849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.11 871.961L1231.61 871.93L1231.63 856.43L1219.13 856.408L1219.23 801.908L1231.73 801.93L1231.76 786.93L1249.26 786.961L1249.11 871.961Z",
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1249.29,
    y: 769.961,
    width: 34,
    height: 51,
    transform: "rotate(-179.899 1249.29 769.961)",
    fill: "#FDC824"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1241.31,
    y: 756.947,
    width: 19,
    height: 25,
    transform: "rotate(-179.899 1241.31 756.947)",
    fill: "#DA982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233.71,
    y: 530.933,
    width: 34,
    height: 68,
    transform: "rotate(-179.899 1233.71 530.933)",
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1221.72,
    y: 523.912,
    width: 10,
    height: 16,
    transform: "rotate(-179.899 1221.72 523.912)",
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1221.77,
    y: 498.912,
    width: 10,
    height: 28,
    transform: "rotate(-179.899 1221.77 498.912)",
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.781,
    y: 489.28,
    width: 34,
    height: 68,
    transform: "rotate(-179.899 862.781 489.28)",
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.793,
    y: 482.258,
    width: 10,
    height: 16,
    transform: "rotate(-179.899 850.793 482.258)",
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.838,
    y: 457.258,
    width: 10,
    height: 28,
    transform: "rotate(-179.899 850.838 457.258)",
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1222.01,
    y: 360.912,
    width: 42,
    height: 78,
    transform: "rotate(-179.899 1222.01 360.912)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1219.01,
    y: 358.907,
    width: 36,
    height: 74,
    transform: "rotate(-179.899 1219.01 358.907)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1228.02,
    y: 353.923,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1228.02 353.923)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1228.05,
    y: 338.923,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1228.05 338.923)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1228.07,
    y: 323.923,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1228.07 323.923)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1228.1,
    y: 308.923,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1228.1 308.923)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1228.12,
    y: 293.923,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1228.12 293.923)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.02,
    y: 353.838,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1180.02 353.838)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.05,
    y: 338.839,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1180.05 338.839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.07,
    y: 323.839,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1180.07 323.839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.1,
    y: 308.839,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1180.1 308.839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.13,
    y: 293.839,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 1180.13 293.839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1192.16,
    y: 276.86,
    width: 6,
    height: 4,
    transform: "rotate(90.101 1192.16 276.86)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1203.16,
    y: 276.879,
    width: 6,
    height: 4,
    transform: "rotate(90.101 1203.16 276.879)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1214.16,
    y: 276.899,
    width: 6,
    height: 4,
    transform: "rotate(90.101 1214.16 276.899)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1192.01,
    y: 360.86,
    width: 6,
    height: 4,
    transform: "rotate(90.101 1192.01 360.86)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1203.01,
    y: 360.879,
    width: 6,
    height: 4,
    transform: "rotate(90.101 1203.01 360.879)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1214.01,
    y: 360.898,
    width: 6,
    height: 4,
    transform: "rotate(90.101 1214.01 360.898)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1521,
    y: 328,
    width: 42,
    height: 78,
    transform: "rotate(-90 1521 328)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1523,
    y: 325,
    width: 36,
    height: 74,
    transform: "rotate(-90 1523 325)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1528,
    y: 334,
    width: 6,
    height: 4,
    transform: "rotate(-90 1528 334)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 334,
    width: 6,
    height: 4,
    transform: "rotate(-90 1543 334)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1558,
    y: 334,
    width: 6,
    height: 4,
    transform: "rotate(-90 1558 334)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1573,
    y: 334,
    width: 6,
    height: 4,
    transform: "rotate(-90 1573 334)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1588,
    y: 334,
    width: 6,
    height: 4,
    transform: "rotate(-90 1588 334)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1528,
    y: 286,
    width: 6,
    height: 4,
    transform: "rotate(-90 1528 286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1543,
    y: 286,
    width: 6,
    height: 4,
    transform: "rotate(-90 1543 286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1558,
    y: 286,
    width: 6,
    height: 4,
    transform: "rotate(-90 1558 286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1573,
    y: 286,
    width: 6,
    height: 4,
    transform: "rotate(-90 1573 286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1588,
    y: 286,
    width: 6,
    height: 4,
    transform: "rotate(-90 1588 286)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1605,
    y: 298,
    width: 6,
    height: 4,
    transform: "rotate(180 1605 298)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1605,
    y: 309,
    width: 6,
    height: 4,
    transform: "rotate(180 1605 309)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1605,
    y: 320,
    width: 6,
    height: 4,
    transform: "rotate(180 1605 320)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1521,
    y: 298,
    width: 6,
    height: 4,
    transform: "rotate(180 1521 298)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1521,
    y: 309,
    width: 6,
    height: 4,
    transform: "rotate(180 1521 309)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1521,
    y: 320,
    width: 6,
    height: 4,
    transform: "rotate(180 1521 320)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.121,
    y: 864.295,
    width: 42,
    height: 78,
    transform: "rotate(-179.899 871.121 864.295)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.125,
    y: 862.289,
    width: 36,
    height: 74,
    transform: "rotate(-179.899 868.125 862.289)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.133,
    y: 857.305,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 877.133 857.305)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.16,
    y: 842.305,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 877.16 842.305)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.186,
    y: 827.305,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 877.186 827.305)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.213,
    y: 812.305,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 877.213 812.305)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.24,
    y: 797.305,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 877.24 797.305)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.133,
    y: 857.221,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 829.133 857.221)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.16,
    y: 842.221,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 829.16 842.221)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.186,
    y: 827.221,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 829.186 827.221)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.213,
    y: 812.221,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 829.213 812.221)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 829.24,
    y: 797.221,
    width: 6,
    height: 4,
    transform: "rotate(-179.899 829.24 797.221)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.27,
    y: 780.242,
    width: 6,
    height: 4,
    transform: "rotate(90.101 841.27 780.242)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852.27,
    y: 780.261,
    width: 6,
    height: 4,
    transform: "rotate(90.101 852.27 780.261)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.27,
    y: 780.281,
    width: 6,
    height: 4,
    transform: "rotate(90.101 863.27 780.281)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.121,
    y: 864.242,
    width: 6,
    height: 4,
    transform: "rotate(90.101 841.121 864.242)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852.121,
    y: 864.261,
    width: 6,
    height: 4,
    transform: "rotate(90.101 852.121 864.261)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.121,
    y: 864.281,
    width: 6,
    height: 4,
    transform: "rotate(90.101 863.121 864.281)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 881,
    width: 42,
    height: 78,
    transform: "rotate(-90 1268 881)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 878,
    width: 36,
    height: 74,
    transform: "rotate(-90 1270 878)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1275,
    y: 887,
    width: 6,
    height: 4,
    transform: "rotate(-90 1275 887)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 887,
    width: 6,
    height: 4,
    transform: "rotate(-90 1290 887)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1305,
    y: 887,
    width: 6,
    height: 4,
    transform: "rotate(-90 1305 887)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 887,
    width: 6,
    height: 4,
    transform: "rotate(-90 1320 887)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 887,
    width: 6,
    height: 4,
    transform: "rotate(-90 1335 887)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1275,
    y: 839,
    width: 6,
    height: 4,
    transform: "rotate(-90 1275 839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 839,
    width: 6,
    height: 4,
    transform: "rotate(-90 1290 839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1305,
    y: 839,
    width: 6,
    height: 4,
    transform: "rotate(-90 1305 839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 839,
    width: 6,
    height: 4,
    transform: "rotate(-90 1320 839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 839,
    width: 6,
    height: 4,
    transform: "rotate(-90 1335 839)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 851,
    width: 6,
    height: 4,
    transform: "rotate(180 1352 851)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 862,
    width: 6,
    height: 4,
    transform: "rotate(180 1352 862)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1352,
    y: 873,
    width: 6,
    height: 4,
    transform: "rotate(180 1352 873)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 851,
    width: 6,
    height: 4,
    transform: "rotate(180 1268 851)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 862,
    width: 6,
    height: 4,
    transform: "rotate(180 1268 862)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1268,
    y: 873,
    width: 6,
    height: 4,
    transform: "rotate(180 1268 873)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190.18,
    y: 261.856,
    width: 318,
    height: 31,
    transform: "rotate(-179.899 1190.18 261.856)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190.2,
    y: 252.856,
    width: 318,
    height: 12,
    transform: "rotate(-179.899 1190.2 252.856)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212.2,
    y: 252.895,
    width: 22,
    height: 12,
    transform: "rotate(-179.899 1212.2 252.895)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.219,
    y: 252.296,
    width: 22,
    height: 12,
    transform: "rotate(-179.899 872.219 252.296)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1192.27,
    y: 212.86,
    width: 318,
    height: 31,
    transform: "rotate(-179.899 1192.27 212.86)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1192.29,
    y: 203.86,
    width: 318,
    height: 12,
    transform: "rotate(-179.899 1192.29 203.86)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1214.29,
    y: 203.899,
    width: 22,
    height: 12,
    transform: "rotate(-179.899 1214.29 203.899)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.305,
    y: 203.3,
    width: 22,
    height: 12,
    transform: "rotate(-179.899 874.305 203.3)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1191.39,
    y: 144.858,
    width: 271,
    height: 31,
    transform: "rotate(-179.899 1191.39 144.858)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1191.4,
    y: 135.858,
    width: 271,
    height: 13,
    transform: "rotate(-179.899 1191.4 135.858)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1191.37,
    y: 154.858,
    width: 271,
    height: 10,
    transform: "rotate(-179.899 1191.37 154.858)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1394,
    y: 331,
    width: 271,
    height: 31,
    transform: "rotate(90 1394 331)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1385,
    y: 331,
    width: 271,
    height: 13,
    transform: "rotate(90 1385 331)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404,
    y: 331,
    width: 271,
    height: 10,
    transform: "rotate(90 1404 331)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190.48,
    y: 92.8564,
    width: 271,
    height: 31,
    transform: "rotate(-179.899 1190.48 92.8564)",
    fill: "#FCCCA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190.5,
    y: 83.8564,
    width: 271,
    height: 13,
    transform: "rotate(-179.899 1190.5 83.8564)",
    fill: "#EBAA79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190.46,
    y: 102.856,
    width: 271,
    height: 10,
    transform: "rotate(-179.899 1190.46 102.856)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1344,
    y: 331,
    width: 271,
    height: 31,
    transform: "rotate(90 1344 331)",
    fill: "#FCCCA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 331,
    width: 271,
    height: 13,
    transform: "rotate(90 1335 331)",
    fill: "#EBAA79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1354,
    y: 331,
    width: 271,
    height: 10,
    transform: "rotate(90 1354 331)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1144.57,
    y: 43.7755,
    width: 43,
    height: 27,
    transform: "rotate(-179.899 1144.57 43.7755)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1137.58,
    y: 37.7632,
    width: 29,
    height: 15,
    transform: "rotate(-179.899 1137.58 37.7632)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1084.57,
    y: 43.6697,
    width: 43,
    height: 27,
    transform: "rotate(-179.899 1084.57 43.6697)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1077.58,
    y: 37.6574,
    width: 29,
    height: 15,
    transform: "rotate(-179.899 1077.58 37.6574)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.57,
    y: 43.564,
    width: 43,
    height: 27,
    transform: "rotate(-179.899 1024.57 43.564)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1017.58,
    y: 37.5516,
    width: 29,
    height: 15,
    transform: "rotate(-179.899 1017.58 37.5516)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.568,
    y: 43.4582,
    width: 43,
    height: 27,
    transform: "rotate(-179.899 964.568 43.4582)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.578,
    y: 37.4459,
    width: 29,
    height: 15,
    transform: "rotate(-179.899 957.578 37.4459)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.777 89.0484C899.427 92.7118 901.473 97.6754 901.464 102.847C901.455 108.019 899.392 112.975 895.728 116.626C892.065 120.276 887.101 122.322 881.93 122.313C876.758 122.304 871.802 120.24 868.151 116.577L881.964 102.813L895.777 89.0484Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.151 116.577C864.501 112.914 862.455 107.95 862.464 102.778C862.473 97.6066 864.536 92.6504 868.2 88.9998C871.863 85.3493 876.827 83.3036 881.998 83.3127C887.17 83.3218 892.126 85.385 895.777 89.0484L881.964 102.813L868.151 116.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.35 1.7701C1372 5.4335 1374.04 10.397 1374.03 15.5687C1374.03 20.7404 1371.96 25.6967 1368.3 29.3472C1364.64 32.9977 1359.67 35.0434 1354.5 35.0343C1349.33 35.0252 1344.37 32.962 1340.72 29.2986L1354.53 15.5344L1368.35 1.7701Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.72 29.2986C1337.07 25.6352 1335.03 20.6717 1335.03 15.5C1335.04 10.3283 1337.11 5.372 1340.77 1.72149C1344.43 -1.92902 1349.4 -3.97473 1354.57 -3.96562C1359.74 -3.9565 1364.7 -1.89331 1368.35 1.77009L1354.53 15.5344L1340.72 29.2986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.35 74.7701C1511 78.4335 1513.04 83.397 1513.03 88.5687C1513.03 93.7404 1510.96 98.6967 1507.3 102.347C1503.64 105.998 1498.67 108.043 1493.5 108.034C1488.33 108.025 1483.37 105.962 1479.72 102.299L1493.53 88.5343L1507.35 74.7701Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.72 102.299C1476.07 98.6352 1474.03 93.6717 1474.03 88.5C1474.04 83.3282 1476.11 78.372 1479.77 74.7215C1483.43 71.071 1488.4 69.0252 1493.57 69.0344C1498.74 69.0435 1503.7 71.1067 1507.35 74.7701L1493.53 88.5343L1479.72 102.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.35 626.77C1373 630.433 1375.04 635.397 1375.03 640.569C1375.03 645.74 1372.96 650.697 1369.3 654.347C1365.64 657.998 1360.67 660.043 1355.5 660.034C1350.33 660.025 1345.37 657.962 1341.72 654.299L1355.53 640.534L1369.35 626.77Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.72 654.299C1338.07 650.635 1336.03 645.672 1336.03 640.5C1336.04 635.328 1338.11 630.372 1341.77 626.721C1345.43 623.071 1350.4 621.025 1355.57 621.034C1360.74 621.043 1365.7 623.107 1369.35 626.77L1355.53 640.534L1341.72 654.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.35 283.77C1381 287.433 1383.04 292.397 1383.03 297.569C1383.03 302.74 1380.96 307.697 1377.3 311.347C1373.64 314.998 1368.67 317.043 1363.5 317.034C1358.33 317.025 1353.37 314.962 1349.72 311.299L1363.53 297.534L1377.35 283.77Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.72 311.299C1346.07 307.635 1344.03 302.672 1344.03 297.5C1344.04 292.328 1346.11 287.372 1349.77 283.721C1353.43 280.071 1358.4 278.025 1363.57 278.034C1368.74 278.043 1373.7 280.107 1377.35 283.77L1363.53 297.534L1349.72 311.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.35 697.77C1511 701.433 1513.04 706.397 1513.03 711.569C1513.03 716.74 1510.96 721.697 1507.3 725.347C1503.64 728.998 1498.67 731.043 1493.5 731.034C1488.33 731.025 1483.37 728.962 1479.72 725.299L1493.53 711.534L1507.35 697.77Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.72 725.299C1476.07 721.635 1474.03 716.672 1474.03 711.5C1474.04 706.328 1476.11 701.372 1479.77 697.721C1483.43 694.071 1488.4 692.025 1493.57 692.034C1498.74 692.043 1503.7 694.107 1507.35 697.77L1493.53 711.534L1479.72 725.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.533 226.921C827.183 230.585 829.229 235.548 829.22 240.72C829.211 245.892 827.148 250.848 823.484 254.498C819.821 258.149 814.857 260.195 809.686 260.186C804.514 260.176 799.558 258.113 795.907 254.45L809.72 240.686L823.533 226.921Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.907 254.45C792.257 250.786 790.211 245.823 790.22 240.651C790.229 235.48 792.292 230.523 795.956 226.873C799.619 223.222 804.583 221.177 809.754 221.186C814.926 221.195 819.882 223.258 823.533 226.921L809.72 240.686L795.907 254.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.56 391.196C1162.37 394.014 1163.94 397.832 1163.94 401.81C1163.93 405.788 1162.34 409.601 1159.52 412.409C1156.71 415.217 1152.89 416.791 1148.91 416.784C1144.93 416.777 1141.12 415.19 1138.31 412.372L1148.94 401.784L1159.56 391.196Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.31 412.372C1135.5 409.554 1133.93 405.736 1133.94 401.757C1133.94 397.779 1135.53 393.967 1138.35 391.158C1141.17 388.35 1144.98 386.777 1148.96 386.784C1152.94 386.791 1156.75 388.378 1159.56 391.196L1148.94 401.784L1138.31 412.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.5 427.15C1136.31 429.968 1137.88 433.786 1137.87 437.764C1137.87 441.743 1136.28 445.555 1133.46 448.363C1130.64 451.171 1126.83 452.745 1122.85 452.738C1118.87 452.731 1115.06 451.144 1112.25 448.326L1122.87 437.738L1133.5 427.15Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.25 448.326C1109.44 445.508 1107.87 441.69 1107.87 437.711C1107.88 433.733 1109.47 429.921 1112.29 427.113C1115.1 424.305 1118.92 422.731 1122.9 422.738C1126.88 422.745 1130.69 424.332 1133.5 427.15L1122.87 437.738L1112.25 448.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.353 509.662C859.161 512.48 860.735 516.298 860.728 520.276C860.721 524.254 859.134 528.067 856.316 530.875C853.498 533.683 849.679 535.256 845.701 535.249C841.723 535.242 837.91 533.655 835.102 530.837L845.728 520.249L856.353 509.662Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.102 530.837C832.294 528.019 830.721 524.201 830.728 520.223C830.735 516.245 832.322 512.432 835.14 509.624C837.958 506.816 841.776 505.242 845.754 505.249C849.732 505.256 853.545 506.844 856.353 509.662L845.728 520.249L835.102 530.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.593 373.709C886.401 376.527 887.975 380.345 887.968 384.324C887.961 388.302 886.374 392.114 883.556 394.923C880.738 397.731 876.92 399.304 872.941 399.297C868.963 399.29 865.151 397.703 862.343 394.885L872.968 384.297L883.593 373.709Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.343 394.885C859.535 392.067 857.961 388.249 857.968 384.271C857.975 380.293 859.562 376.48 862.38 373.672C865.198 370.864 869.016 369.29 872.994 369.297C876.973 369.304 880.785 370.891 883.593 373.709L872.968 384.297L862.343 394.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.671 328.709C886.479 331.527 888.053 335.346 888.046 339.324C888.039 343.302 886.452 347.115 883.634 349.923C880.816 352.731 876.998 354.304 873.02 354.297C869.041 354.29 865.229 352.703 862.421 349.885L873.046 339.297L883.671 328.709Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.421 349.885C859.613 347.067 858.039 343.249 858.046 339.271C858.053 335.293 859.64 331.48 862.458 328.672C865.276 325.864 869.094 324.29 873.072 324.297C877.051 324.304 880.863 325.891 883.671 328.709L873.046 339.297L862.421 349.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.751 283.71C886.559 286.528 888.133 290.346 888.126 294.324C888.119 298.302 886.532 302.115 883.714 304.923C880.896 307.731 877.078 309.304 873.1 309.297C869.121 309.29 865.309 307.703 862.501 304.885L873.126 294.297L883.751 283.71Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.501 304.885C859.693 302.067 858.119 298.249 858.126 294.271C858.133 290.293 859.72 286.48 862.538 283.672C865.356 280.864 869.174 279.29 873.153 279.297C877.131 279.304 880.943 280.892 883.751 283.71L873.126 294.297L862.501 304.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1558.65 12.4385C1561.46 15.2565 1563.03 19.0746 1563.03 23.0528C1563.02 27.0311 1561.43 30.8436 1558.61 33.6517C1555.8 36.4598 1551.98 38.0334 1548 38.0264C1544.02 38.0194 1540.21 36.4323 1537.4 33.6143L1548.03 23.0264L1558.65 12.4385Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.4 33.6143C1534.59 30.7963 1533.02 26.9782 1533.03 23C1533.03 19.0217 1534.62 15.2092 1537.44 12.4011C1540.26 9.59305 1544.07 8.01942 1548.05 8.02643C1552.03 8.03344 1555.84 9.62052 1558.65 12.4385L1548.03 23.0264L1537.4 33.6143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.65 12.4385C1606.46 15.2565 1608.03 19.0746 1608.03 23.0528C1608.02 27.0311 1606.43 30.8436 1603.61 33.6517C1600.8 36.4598 1596.98 38.0334 1593 38.0264C1589.02 38.0194 1585.21 36.4323 1582.4 33.6143L1593.03 23.0264L1603.65 12.4385Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.4 33.6143C1579.59 30.7963 1578.02 26.9782 1578.03 23C1578.03 19.0217 1579.62 15.2092 1582.44 12.4011C1585.26 9.59305 1589.07 8.01942 1593.05 8.02643C1597.03 8.03344 1600.84 9.62052 1603.65 12.4385L1593.03 23.0264L1582.4 33.6143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.65 12.4385C1651.46 15.2565 1653.03 19.0746 1653.03 23.0528C1653.02 27.0311 1651.43 30.8436 1648.61 33.6517C1645.8 36.4598 1641.98 38.0334 1638 38.0264C1634.02 38.0194 1630.21 36.4323 1627.4 33.6143L1638.03 23.0264L1648.65 12.4385Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.4 33.6143C1624.59 30.7963 1623.02 26.9782 1623.03 23C1623.03 19.0217 1624.62 15.2092 1627.44 12.4011C1630.26 9.59305 1634.07 8.01942 1638.05 8.02643C1642.03 8.03344 1645.84 9.62052 1648.65 12.4385L1638.03 23.0264L1627.4 33.6143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.65 362.439C1666.46 365.257 1668.03 369.075 1668.03 373.053C1668.02 377.031 1666.43 380.844 1663.61 383.652C1660.8 386.46 1656.98 388.033 1653 388.026C1649.02 388.019 1645.21 386.432 1642.4 383.614L1653.03 373.026L1663.65 362.439Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.4 383.614C1639.59 380.796 1638.02 376.978 1638.03 373C1638.03 369.022 1639.62 365.209 1642.44 362.401C1645.26 359.593 1649.07 358.019 1653.05 358.026C1657.03 358.033 1660.84 359.621 1663.65 362.439L1653.03 373.026L1642.4 383.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.65 638.439C1559.46 641.257 1561.03 645.075 1561.03 649.053C1561.02 653.031 1559.43 656.844 1556.61 659.652C1553.8 662.46 1549.98 664.033 1546 664.026C1542.02 664.019 1538.21 662.432 1535.4 659.614L1546.03 649.026L1556.65 638.439Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.4 659.614C1532.59 656.796 1531.02 652.978 1531.03 649C1531.03 645.022 1532.62 641.209 1535.44 638.401C1538.26 635.593 1542.07 634.019 1546.05 634.026C1550.03 634.033 1553.84 635.621 1556.65 638.439L1546.03 649.026L1535.4 659.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1601.65 638.439C1604.46 641.257 1606.03 645.075 1606.03 649.053C1606.02 653.031 1604.43 656.844 1601.61 659.652C1598.8 662.46 1594.98 664.033 1591 664.026C1587.02 664.019 1583.21 662.432 1580.4 659.614L1591.03 649.026L1601.65 638.439Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.4 659.614C1577.59 656.796 1576.02 652.978 1576.03 649C1576.03 645.022 1577.62 641.209 1580.44 638.401C1583.26 635.593 1587.07 634.019 1591.05 634.026C1595.03 634.033 1598.84 635.621 1601.65 638.439L1591.03 649.026L1580.4 659.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.65 638.439C1649.46 641.257 1651.03 645.075 1651.03 649.053C1651.02 653.031 1649.43 656.844 1646.61 659.652C1643.8 662.46 1639.98 664.033 1636 664.026C1632.02 664.019 1628.21 662.432 1625.4 659.614L1636.03 649.026L1646.65 638.439Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.4 659.614C1622.59 656.796 1621.02 652.978 1621.03 649C1621.03 645.022 1622.62 641.209 1625.44 638.401C1628.26 635.593 1632.07 634.019 1636.05 634.026C1640.03 634.033 1643.84 635.621 1646.65 638.439L1636.03 649.026L1625.4 659.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.76 848.925C1008.56 851.743 1010.14 855.562 1010.13 859.54C1010.12 863.518 1008.54 867.331 1005.72 870.139C1002.9 872.947 999.082 874.52 995.104 874.513C991.125 874.506 987.313 872.919 984.505 870.101L995.13 859.513L1005.76 848.925Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.505 870.101C981.697 867.283 980.123 863.465 980.13 859.487C980.137 855.509 981.724 851.696 984.542 848.888C987.36 846.08 991.178 844.506 995.156 844.513C999.135 844.52 1002.95 846.107 1005.76 848.925L995.13 859.513L984.505 870.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.755 848.844C962.563 851.662 964.137 855.48 964.13 859.459C964.123 863.437 962.536 867.249 959.718 870.058C956.9 872.866 953.082 874.439 949.104 874.432C945.125 874.425 941.313 872.838 938.505 870.02L949.13 859.432L959.755 848.844Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.505 870.02C935.697 867.202 934.123 863.384 934.13 859.406C934.137 855.428 935.724 851.615 938.542 848.807C941.36 845.999 945.178 844.425 949.156 844.432C953.135 844.439 956.947 846.026 959.755 848.844L949.13 859.432L938.505 870.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.755 848.763C916.563 851.581 918.137 855.399 918.13 859.378C918.123 863.356 916.536 867.168 913.718 869.976C910.9 872.785 907.082 874.358 903.104 874.351C899.125 874.344 895.313 872.757 892.505 869.939L903.13 859.351L913.755 848.763Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.505 869.939C889.697 867.121 888.123 863.303 888.13 859.325C888.137 855.347 889.724 851.534 892.542 848.726C895.36 845.918 899.178 844.344 903.156 844.351C907.135 844.358 910.947 845.945 913.755 848.763L903.13 859.351L892.505 869.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.83 804.934C1008.64 807.752 1010.21 811.57 1010.21 815.548C1010.2 819.526 1008.61 823.339 1005.79 826.147C1002.98 828.955 999.158 830.528 995.18 830.521C991.201 830.514 987.389 828.927 984.581 826.109L995.206 815.521L1005.83 804.934Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.581 826.109C981.773 823.291 980.199 819.473 980.206 815.495C980.213 811.517 981.8 807.704 984.618 804.896C987.436 802.088 991.254 800.515 995.233 800.522C999.211 800.529 1003.02 802.116 1005.83 804.934L995.206 815.521L984.581 826.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.831 804.853C962.64 807.671 964.213 811.489 964.206 815.467C964.199 819.445 962.612 823.258 959.794 826.066C956.976 828.874 953.158 830.447 949.18 830.44C945.201 830.433 941.389 828.846 938.581 826.028L949.206 815.44L959.831 804.853Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.581 826.028C935.773 823.21 934.199 819.392 934.206 815.414C934.213 811.436 935.8 807.623 938.618 804.815C941.436 802.007 945.254 800.433 949.233 800.44C953.211 800.447 957.023 802.035 959.831 804.853L949.206 815.44L938.581 826.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.831 804.771C916.64 807.589 918.213 811.408 918.206 815.386C918.199 819.364 916.612 823.177 913.794 825.985C910.976 828.793 907.158 830.366 903.18 830.359C899.201 830.352 895.389 828.765 892.581 825.947L903.206 815.359L913.831 804.771Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.581 825.947C889.773 823.129 888.199 819.311 888.206 815.333C888.213 811.355 889.8 807.542 892.618 804.734C895.436 801.926 899.254 800.352 903.233 800.359C907.211 800.366 911.023 801.953 913.831 804.771L903.206 815.359L892.581 825.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1158,
    y: 365.8,
    width: 39,
    height: 91,
    transform: "rotate(-179.899 1158 365.8)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150.02,
    y: 356.786,
    width: 23,
    height: 72,
    transform: "rotate(-179.899 1150.02 356.786)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1142.03,
    y: 349.772,
    width: 7,
    height: 13,
    transform: "rotate(-179.899 1142.03 349.772)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1142.07,
    y: 324.772,
    width: 7,
    height: 34,
    transform: "rotate(-179.899 1142.07 324.772)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1618,
    y: 363,
    width: 39,
    height: 91,
    transform: "rotate(90 1618 363)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1609,
    y: 371,
    width: 23,
    height: 72,
    transform: "rotate(90 1609 371)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602,
    y: 379,
    width: 7,
    height: 13,
    transform: "rotate(90 1602 379)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1577,
    y: 379,
    width: 7,
    height: 34,
    transform: "rotate(90 1577 379)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.828,
    y: 463.01,
    width: 39,
    height: 91,
    transform: "rotate(-89.899 709.828 463.01)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718.842,
    y: 455.026,
    width: 23,
    height: 72,
    transform: "rotate(-89.899 718.842 455.026)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 725.855,
    y: 447.038,
    width: 7,
    height: 13,
    transform: "rotate(-89.899 725.855 447.038)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750.855,
    y: 447.082,
    width: 7,
    height: 34,
    transform: "rotate(-89.899 750.855 447.082)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.91,
    y: 414.724,
    width: 47,
    height: 24,
    transform: "rotate(-179.899 1114.91 414.724)",
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1107.93,
    y: 407.711,
    width: 33,
    height: 10,
    transform: "rotate(-179.899 1107.93 407.711)",
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1046.88,
    y: 431.604,
    width: 35,
    height: 36,
    transform: "rotate(-179.899 1046.88 431.604)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1043.89,
    y: 428.599,
    width: 29,
    height: 30,
    transform: "rotate(-179.899 1043.89 428.599)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1039.95,
    y: 395.591,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1039.95 395.591)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030.95,
    y: 395.576,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1030.95 395.576)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1021.95,
    y: 395.56,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1021.95 395.56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1039.88,
    y: 436.592,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1039.88 436.592)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030.88,
    y: 436.576,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1030.88 436.576)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1021.88,
    y: 436.56,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1021.88 436.56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011.93,
    y: 406.542,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1011.93 406.542)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011.91,
    y: 415.542,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1011.91 415.542)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011.89,
    y: 424.542,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1011.89 424.542)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1051.93,
    y: 406.613,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1051.93 406.613)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1051.91,
    y: 415.613,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1051.91 415.613)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1051.89,
    y: 424.613,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1051.89 424.613)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1682.01,
    y: 508.071,
    width: 35,
    height: 36,
    transform: "rotate(-179.899 1682.01 508.071)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1679.02,
    y: 505.065,
    width: 29,
    height: 30,
    transform: "rotate(-179.899 1679.02 505.065)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1675.07,
    y: 472.058,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1675.07 472.058)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1666.07,
    y: 472.042,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1666.07 472.042)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1657.07,
    y: 472.026,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1657.07 472.026)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1675,
    y: 513.058,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1675 513.058)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1666,
    y: 513.043,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1666 513.043)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1657,
    y: 513.027,
    width: 3,
    height: 5,
    transform: "rotate(-179.899 1657 513.027)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1647.05,
    y: 483.009,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1647.05 483.009)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1647.04,
    y: 492.009,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1647.04 492.009)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1647.02,
    y: 501.009,
    width: 5,
    height: 3,
    transform: "rotate(-179.899 1647.02 501.009)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1106.1,
    y: 310.708,
    width: 102,
    height: 35,
    transform: "rotate(-179.899 1106.1 310.708)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1106.12,
    y: 300.708,
    width: 102,
    height: 16,
    transform: "rotate(-179.899 1106.12 300.708)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1096.12,
    y: 300.69,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1096.12 300.69)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1084.12,
    y: 300.669,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1084.12 300.669)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1071.12,
    y: 300.646,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1071.12 300.646)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1058.12,
    y: 300.623,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1058.12 300.623)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1045.12,
    y: 300.601,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1045.12 300.601)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.12,
    y: 300.578,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1032.12 300.578)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020.12,
    y: 300.556,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1020.12 300.556)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1106,
    y: 365.708,
    width: 102,
    height: 35,
    transform: "rotate(-179.899 1106 365.708)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1106.02,
    y: 355.708,
    width: 102,
    height: 16,
    transform: "rotate(-179.899 1106.02 355.708)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1096.02,
    y: 355.69,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1096.02 355.69)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1084.02,
    y: 355.669,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1084.02 355.669)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1071.02,
    y: 355.646,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1071.02 355.646)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1058.02,
    y: 355.623,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1058.02 355.623)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1045.02,
    y: 355.6,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1045.02 355.6)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.02,
    y: 355.577,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1032.02 355.577)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020.02,
    y: 355.556,
    width: 6,
    height: 16,
    transform: "rotate(-179.899 1020.02 355.556)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 518,
    width: 102,
    height: 35,
    transform: "rotate(-90 1527 518)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 518,
    width: 102,
    height: 16,
    transform: "rotate(-90 1537 518)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 508,
    width: 6,
    height: 16,
    transform: "rotate(-90 1537 508)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 496,
    width: 6,
    height: 16,
    transform: "rotate(-90 1537 496)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 483,
    width: 6,
    height: 16,
    transform: "rotate(-90 1537 483)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 470,
    width: 6,
    height: 16,
    transform: "rotate(-90 1537 470)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 457,
    width: 6,
    height: 16,
    transform: "rotate(-90 1537 457)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 444,
    width: 6,
    height: 16,
    transform: "rotate(-90 1537 444)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1537,
    y: 432,
    width: 6,
    height: 16,
    transform: "rotate(-90 1537 432)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1582,
    y: 518,
    width: 102,
    height: 35,
    transform: "rotate(-90 1582 518)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 518,
    width: 102,
    height: 16,
    transform: "rotate(-90 1592 518)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 508,
    width: 6,
    height: 16,
    transform: "rotate(-90 1592 508)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 496,
    width: 6,
    height: 16,
    transform: "rotate(-90 1592 496)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 483,
    width: 6,
    height: 16,
    transform: "rotate(-90 1592 483)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 470,
    width: 6,
    height: 16,
    transform: "rotate(-90 1592 470)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 457,
    width: 6,
    height: 16,
    transform: "rotate(-90 1592 457)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 444,
    width: 6,
    height: 16,
    transform: "rotate(-90 1592 444)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1592,
    y: 432,
    width: 6,
    height: 16,
    transform: "rotate(-90 1592 432)",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 985.896,
    y: 424.496,
    width: 34,
    height: 149,
    transform: "rotate(-179.899 985.896 424.496)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.923,
    cy: 409.479,
    r: 4,
    transform: "rotate(-179.899 975.923 409.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.923,
    cy: 409.454,
    r: 4,
    transform: "rotate(-179.899 961.923 409.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.952,
    cy: 392.479,
    r: 4,
    transform: "rotate(-179.899 975.952 392.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.952,
    cy: 392.454,
    r: 4,
    transform: "rotate(-179.899 961.952 392.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.984,
    cy: 375.479,
    r: 4,
    transform: "rotate(-179.899 975.984 375.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.984,
    cy: 375.454,
    r: 4,
    transform: "rotate(-179.899 961.984 375.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.013,
    cy: 358.479,
    r: 4,
    transform: "rotate(-179.899 976.013 358.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.013,
    cy: 358.454,
    r: 4,
    transform: "rotate(-179.899 962.013 358.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.042,
    cy: 341.479,
    r: 4,
    transform: "rotate(-179.899 976.042 341.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.042,
    cy: 341.454,
    r: 4,
    transform: "rotate(-179.899 962.042 341.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.073,
    cy: 324.479,
    r: 4,
    transform: "rotate(-179.899 976.073 324.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.073,
    cy: 324.454,
    r: 4,
    transform: "rotate(-179.899 962.073 324.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.103,
    cy: 307.479,
    r: 4,
    transform: "rotate(-179.899 976.103 307.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.103,
    cy: 307.454,
    r: 4,
    transform: "rotate(-179.899 962.103 307.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.132,
    cy: 290.479,
    r: 4,
    transform: "rotate(-179.899 976.132 290.479)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962.132,
    cy: 290.454,
    r: 4,
    transform: "rotate(-179.899 962.132 290.454)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1527,
    y: 568,
    width: 34,
    height: 149,
    transform: "rotate(-90 1527 568)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1542 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1542 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1559,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1559 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1559,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1559 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1576,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1576 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1576,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1576 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1593,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1593 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1593,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1593 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1610 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1610,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1610 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1627,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1627 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1627,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1627 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1644,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1644 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1644,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1644 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1661,
    cy: 558,
    r: 4,
    transform: "rotate(-90 1661 558)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1661,
    cy: 544,
    r: 4,
    transform: "rotate(-90 1661 544)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 938.896,
    y: 424.414,
    width: 34,
    height: 149,
    transform: "rotate(-179.899 938.896 424.414)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.923,
    cy: 409.396,
    r: 4,
    transform: "rotate(-179.899 928.923 409.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914.923,
    cy: 409.371,
    r: 4,
    transform: "rotate(-179.899 914.923 409.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.952,
    cy: 392.396,
    r: 4,
    transform: "rotate(-179.899 928.952 392.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914.952,
    cy: 392.371,
    r: 4,
    transform: "rotate(-179.899 914.952 392.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 928.984,
    cy: 375.396,
    r: 4,
    transform: "rotate(-179.899 928.984 375.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914.984,
    cy: 375.371,
    r: 4,
    transform: "rotate(-179.899 914.984 375.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.013,
    cy: 358.396,
    r: 4,
    transform: "rotate(-179.899 929.013 358.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.013,
    cy: 358.371,
    r: 4,
    transform: "rotate(-179.899 915.013 358.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.042,
    cy: 341.396,
    r: 4,
    transform: "rotate(-179.899 929.042 341.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.042,
    cy: 341.371,
    r: 4,
    transform: "rotate(-179.899 915.042 341.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.073,
    cy: 324.396,
    r: 4,
    transform: "rotate(-179.899 929.073 324.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.073,
    cy: 324.371,
    r: 4,
    transform: "rotate(-179.899 915.073 324.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.103,
    cy: 307.396,
    r: 4,
    transform: "rotate(-179.899 929.103 307.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.103,
    cy: 307.371,
    r: 4,
    transform: "rotate(-179.899 915.103 307.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.132,
    cy: 290.396,
    r: 4,
    transform: "rotate(-179.899 929.132 290.396)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.132,
    cy: 290.371,
    r: 4,
    transform: "rotate(-179.899 915.132 290.371)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1528,
    y: 616,
    width: 34,
    height: 149,
    transform: "rotate(-90 1528 616)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1543,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1543 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1543,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1543 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1560,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1560 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1560,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1560 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1577,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1577 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1577,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1577 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1594,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1594 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1594,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1594 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1611,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1611 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1611,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1611 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1628,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1628 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1628,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1628 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1645,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1645 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1645,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1645 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1662,
    cy: 606,
    r: 4,
    transform: "rotate(-90 1662 606)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1662,
    cy: 592,
    r: 4,
    transform: "rotate(-90 1662 592)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 883.525,
    y: 67.3154,
    width: 79,
    height: 51,
    transform: "rotate(-179.899 883.525 67.3154)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.547,
    y: 55.2961,
    width: 55,
    height: 26,
    transform: "rotate(-179.899 872.547 55.2961)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1267,
    y: 93,
    width: 79,
    height: 51,
    transform: "rotate(-90 1267 93)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 82,
    width: 55,
    height: 26,
    transform: "rotate(-90 1279 82)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.525,
    y: 67.1392,
    width: 79,
    height: 51,
    transform: "rotate(-179.899 783.525 67.1392)",
    fill: "#FCCCA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 772.547,
    y: 55.1198,
    width: 55,
    height: 26,
    transform: "rotate(-179.899 772.547 55.1198)",
    fill: "#EBAA79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1267,
    y: 191,
    width: 79,
    height: 51,
    transform: "rotate(-90 1267 191)",
    fill: "#FCCCA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1279,
    y: 180,
    width: 55,
    height: 26,
    transform: "rotate(-90 1279 180)",
    fill: "#EBAA79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.9,
    y: 421.982,
    width: 53,
    height: 28,
    transform: "rotate(-179.899 693.9 421.982)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.916,
    y: 412.982,
    width: 53,
    height: 11,
    transform: "rotate(-179.899 693.916 412.982)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1647,
    y: 255,
    width: 53,
    height: 28,
    transform: "rotate(-90 1647 255)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656,
    y: 255,
    width: 53,
    height: 11,
    transform: "rotate(-90 1656 255)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1644,
    y: 880,
    width: 53,
    height: 28,
    transform: "rotate(-90 1644 880)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1653,
    y: 880,
    width: 53,
    height: 11,
    transform: "rotate(-90 1653 880)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.824,
    y: 464.981,
    width: 53,
    height: 28,
    transform: "rotate(-179.899 693.824 464.981)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693.84,
    y: 455.981,
    width: 53,
    height: 11,
    transform: "rotate(-179.899 693.84 455.981)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 771.188,
    y: 259.118,
    width: 82,
    height: 38,
    transform: "rotate(-179.899 771.188 259.118)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 763.199,
    y: 252.104,
    width: 64,
    height: 24,
    transform: "rotate(-179.899 763.199 252.104)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1475,
    y: 207,
    width: 82,
    height: 38,
    transform: "rotate(-90 1475 207)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1482,
    y: 199,
    width: 64,
    height: 24,
    transform: "rotate(-90 1482 199)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1473,
    y: 831,
    width: 82,
    height: 38,
    transform: "rotate(-90 1473 831)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 823,
    width: 64,
    height: 24,
    transform: "rotate(-90 1480 823)",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.357 163.347L835.358 163.231L901.391 144.347L901.357 163.347Z",
    fill: "#8E929E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.391 144.231L901.391 144.347L835.357 163.231L835.391 144.231Z",
    fill: "#5F6573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396 62V-4L1415 62H1396Z",
    fill: "#8E929E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 -4V62L1396 -4H1415Z",
    fill: "#5F6573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396 687V621L1415 687H1396Z",
    fill: "#8E929E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 621V687L1396 621H1415Z",
    fill: "#5F6573"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.307,
    y: 190.92,
    width: 33,
    height: 59,
    transform: "rotate(-179.899 659.307 190.92)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.307,
    y: 190.949,
    width: 16,
    height: 59,
    transform: "rotate(-179.899 675.307 190.949)",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 238,
    width: 33,
    height: 59,
    transform: "rotate(90 1443 238)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 222,
    width: 16,
    height: 59,
    transform: "rotate(90 1443 222)",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 861,
    width: 33,
    height: 59,
    transform: "rotate(90 1443 861)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 845,
    width: 16,
    height: 59,
    transform: "rotate(90 1443 845)",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1617,
    y: 238,
    width: 33,
    height: 59,
    transform: "rotate(90 1617 238)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1617,
    y: 222,
    width: 16,
    height: 59,
    transform: "rotate(90 1617 222)",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1616,
    y: 862,
    width: 33,
    height: 59,
    transform: "rotate(90 1616 862)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1616,
    y: 846,
    width: 16,
    height: 59,
    transform: "rotate(90 1616 846)",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658,
    y: 365.918,
    width: 33,
    height: 59,
    transform: "rotate(-179.899 658 365.918)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 674,
    y: 365.946,
    width: 16,
    height: 59,
    transform: "rotate(-179.899 674 365.946)",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.152,
    y: 278.92,
    width: 33,
    height: 59,
    transform: "rotate(-179.899 659.152 278.92)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.152,
    y: 278.948,
    width: 16,
    height: 59,
    transform: "rotate(-179.899 675.152 278.948)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 238,
    width: 33,
    height: 59,
    transform: "rotate(90 1530 238)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 222,
    width: 16,
    height: 59,
    transform: "rotate(90 1530 222)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 863,
    width: 33,
    height: 59,
    transform: "rotate(90 1530 863)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 847,
    width: 16,
    height: 59,
    transform: "rotate(90 1530 847)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.412,
    y: 132.257,
    width: 20,
    height: 53,
    transform: "rotate(-179.899 850.412 132.257)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.422,
    y: 127.25,
    width: 11,
    height: 42,
    transform: "rotate(-179.899 846.422 127.25)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 842.43,
    y: 122.243,
    width: 4,
    height: 7,
    transform: "rotate(-179.899 842.43 122.243)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 842.455,
    y: 108.243,
    width: 4,
    height: 20,
    transform: "rotate(-179.899 842.455 108.243)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1331,
    y: 66,
    width: 20,
    height: 53,
    transform: "rotate(-90 1331 66)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1336,
    y: 62,
    width: 11,
    height: 42,
    transform: "rotate(-90 1336 62)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 58,
    width: 4,
    height: 7,
    transform: "rotate(-90 1341 58)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1355,
    y: 58,
    width: 4,
    height: 20,
    transform: "rotate(-90 1355 58)",
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.389,
    y: 97.0941,
    width: 94,
    height: 95,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.389,
    y: 105.094,
    width: 80,
    height: 79,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.389,
    y: 97.0941,
    width: 6,
    height: 95,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.389,
    y: 140.094,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.389,
    y: 116.094,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 802.389,
    y: 164.094,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.389,
    y: 140.094,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.389,
    y: 116.094,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.389,
    y: 164.094,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750.389,
    y: 192.094,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.389,
    y: 192.094,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 726.389,
    y: 192.094,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750.389,
    y: 83.0941,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.389,
    y: 83.0941,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 726.389,
    y: 83.0941,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.389,
    y: 192.094,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 759.389,
    y: 192.094,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.389,
    y: 192.094,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.389,
    y: 83.0941,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 759.389,
    y: 83.0941,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.389,
    y: 83.0941,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 816.389,
    y: 164.094,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 816.389,
    y: 140.094,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 816.389,
    y: 116.094,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1349,
    y: 89,
    width: 94,
    height: 95,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1356,
    y: 97,
    width: 80,
    height: 79,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 89,
    width: 6,
    height: 95,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 132,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 108,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 156,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 132,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 108,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 156,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1391,
    y: 184,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415,
    y: 184,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1367,
    y: 184,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1391,
    y: 75,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415,
    y: 75,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1367,
    y: 75,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1376,
    y: 184,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 184,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1424,
    y: 184,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1376,
    y: 75,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 75,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1424,
    y: 75,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1457,
    y: 156,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1457,
    y: 132,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1457,
    y: 108,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1349,
    y: 715,
    width: 94,
    height: 95,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1356,
    y: 723,
    width: 80,
    height: 79,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 715,
    width: 6,
    height: 95,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 758,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 734,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 782,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 758,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 734,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1335,
    y: 782,
    width: 14,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1391,
    y: 810,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415,
    y: 810,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1367,
    y: 810,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1391,
    y: 701,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1415,
    y: 701,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1367,
    y: 701,
    width: 9,
    height: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1376,
    y: 810,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 810,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1424,
    y: 810,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1376,
    y: 701,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 701,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1424,
    y: 701,
    width: 6,
    height: 14,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1457,
    y: 782,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1457,
    y: 758,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1457,
    y: 734,
    width: 5,
    height: 9,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.938,
    y: 401.237,
    width: 126,
    height: 126,
    rx: 5,
    transform: "rotate(-179.899 838.938 401.237)",
    fill: "#5F6571"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.02,
    y: 354.237,
    width: 126,
    height: 12,
    transform: "rotate(-179.899 839.02 354.237)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 812.963,
    y: 386.191,
    width: 80,
    height: 15,
    transform: "rotate(-179.899 812.963 386.191)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.066,
    y: 327.237,
    width: 126,
    height: 12,
    transform: "rotate(-179.899 839.066 327.237)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 839.117,
    y: 299.237,
    width: 126,
    height: 12,
    transform: "rotate(-179.899 839.117 299.237)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1525,
    y: 184,
    width: 126,
    height: 126,
    rx: 5,
    transform: "rotate(-90 1525 184)",
    fill: "#5F6571"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1572,
    y: 184,
    width: 126,
    height: 12,
    transform: "rotate(-90 1572 184)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 158,
    width: 80,
    height: 15,
    transform: "rotate(-90 1540 158)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1599,
    y: 184,
    width: 126,
    height: 12,
    transform: "rotate(-90 1599 184)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1627,
    y: 184,
    width: 126,
    height: 12,
    transform: "rotate(-90 1627 184)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1653,
    y: 686,
    width: 126,
    height: 126,
    rx: 5,
    transform: "rotate(90 1653 686)",
    fill: "#5F6571"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1606,
    y: 686,
    width: 126,
    height: 12,
    transform: "rotate(90 1606 686)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638,
    y: 712,
    width: 80,
    height: 15,
    transform: "rotate(90 1638 712)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1579,
    y: 686,
    width: 126,
    height: 12,
    transform: "rotate(90 1579 686)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1551,
    y: 686,
    width: 126,
    height: 12,
    transform: "rotate(90 1551 686)",
    fill: "#8C929E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 921.277,
    cy: 490.883,
    rx: 24.5,
    ry: 25.5,
    transform: "rotate(-179.899 921.277 490.883)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 921.278,
    cy: 491.383,
    rx: 18.5,
    ry: 18,
    transform: "rotate(-179.899 921.278 491.383)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.778 490.809C879.819 467.89 898.432 449.342 921.351 449.383C944.271 449.423 962.819 468.036 962.778 490.956C962.738 513.876 944.125 532.423 921.205 532.383C898.285 532.342 879.738 513.729 879.778 490.809ZM956.875 490.945C956.909 471.286 941 455.321 921.341 455.286C901.682 455.252 885.717 471.161 885.682 490.82C885.647 510.479 901.556 526.444 921.216 526.479C940.875 526.513 956.84 510.605 956.875 490.945Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.72 522.69L988.723 522.502L988.75 507.002L999.75 507.021L999.789 485.021L999.819 468.021L988.819 468.002L988.846 452.502L1095.85 452.69L1095.82 468.19L1082.82 468.167L1082.78 487.667L1082.75 507.167L1095.75 507.19L1095.72 522.69Z",
    fill: "#5E6470"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1069.74,
    y: 515.644,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1069.74 515.644)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.74,
    y: 515.634,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1063.74 515.634)",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1057.74,
    y: 515.623,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1057.74 515.623)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1051.74,
    y: 515.613,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1051.74 515.613)",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1045.74,
    y: 515.602,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1045.74 515.602)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1039.74,
    y: 515.591,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1039.74 515.591)",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.74,
    y: 515.581,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1033.74 515.581)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1021.74,
    y: 515.56,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1021.74 515.56)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.74,
    y: 515.57,
    width: 6,
    height: 55,
    transform: "rotate(-179.899 1027.74 515.57)",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1085.83,
    cy: 460.673,
    r: 3,
    transform: "rotate(-179.899 1085.83 460.673)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1085.74,
    cy: 515.672,
    r: 3,
    transform: "rotate(-179.899 1085.74 515.672)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 999.736,
    cy: 515.521,
    r: 3,
    transform: "rotate(-179.899 999.736 515.521)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 999.833,
    cy: 460.521,
    r: 3,
    transform: "rotate(-179.899 999.833 460.521)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 999.768,
    y: 497.521,
    width: 27,
    height: 19,
    transform: "rotate(-179.899 999.768 497.521)",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 986.775,
    y: 493.498,
    width: 9,
    height: 12,
    transform: "rotate(-179.899 986.775 493.498)",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.72 522.697L1095.72 522.69L1095.75 507.19L1099.75 507.197L1099.72 522.697Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.82 468.197L1095.82 468.19L1095.85 452.69L1099.85 452.697L1099.82 468.197Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.8 478.734L1120.79 482.734L1082.79 482.667L1082.8 478.667L1120.8 478.734Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.77 493.736L1121.77 497.736L1082.77 497.667L1082.77 493.667L1121.77 493.736Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.57 611.743L1120.57 611.734L1120.8 478.734L1125.8 478.743L1125.57 611.743Z",
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.62,
    y: 556.618,
    width: 46,
    height: 47,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.62,
    y: 560.618,
    width: 40,
    height: 39,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.62,
    y: 556.618,
    width: 4,
    height: 47,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.62,
    y: 577.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.62,
    y: 565.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.62,
    y: 589.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.62,
    y: 577.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.62,
    y: 565.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.62,
    y: 589.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.62,
    y: 577.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.62,
    y: 565.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.62,
    y: 589.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.62,
    y: 603.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.62,
    y: 603.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.62,
    y: 603.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.62,
    y: 603.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.62,
    y: 603.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.62,
    y: 603.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.62,
    y: 550.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.62,
    y: 550.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.62,
    y: 550.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.62,
    y: 550.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.62,
    y: 550.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.62,
    y: 550.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.33,
    y: 723.617,
    width: 46,
    height: 47,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.33,
    y: 727.617,
    width: 40,
    height: 39,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.33,
    y: 723.617,
    width: 4,
    height: 47,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.33,
    y: 744.617,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.33,
    y: 732.617,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.33,
    y: 756.617,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.33,
    y: 744.617,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.33,
    y: 732.617,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.33,
    y: 756.617,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.33,
    y: 744.617,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.33,
    y: 732.617,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.33,
    y: 756.617,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.33,
    y: 770.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.33,
    y: 770.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.33,
    y: 770.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.33,
    y: 770.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.33,
    y: 770.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.33,
    y: 770.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.33,
    y: 717.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.33,
    y: 717.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.33,
    y: 717.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.33,
    y: 717.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.33,
    y: 717.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.33,
    y: 717.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.47,
    y: 628.618,
    width: 46,
    height: 71,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.47,
    y: 632.618,
    width: 40,
    height: 63,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.47,
    y: 628.618,
    width: 4,
    height: 71,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.47,
    y: 638.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.47,
    y: 661.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.47,
    y: 685.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.47,
    y: 638.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.47,
    y: 661.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.47,
    y: 685.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.47,
    y: 638.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.47,
    y: 661.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.47,
    y: 685.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.47,
    y: 699.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.47,
    y: 699.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.47,
    y: 699.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.47,
    y: 699.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.47,
    y: 699.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.47,
    y: 699.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.47,
    y: 622.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.47,
    y: 622.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.47,
    y: 622.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.47,
    y: 622.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.47,
    y: 622.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.47,
    y: 622.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.18,
    y: 793.618,
    width: 46,
    height: 71,
    fill: "#5F636C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.18,
    y: 797.618,
    width: 40,
    height: 63,
    fill: "#41444D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.18,
    y: 793.618,
    width: 4,
    height: 71,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.18,
    y: 803.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.18,
    y: 826.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.18,
    y: 850.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.18,
    y: 803.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.18,
    y: 826.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.18,
    y: 850.618,
    width: 6,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.18,
    y: 803.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.18,
    y: 826.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.18,
    y: 850.618,
    width: 4,
    height: 4,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.18,
    y: 864.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.18,
    y: 864.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.18,
    y: 864.617,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.18,
    y: 864.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.18,
    y: 864.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.18,
    y: 864.617,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.18,
    y: 787.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.18,
    y: 787.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.18,
    y: 787.618,
    width: 4,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1054.18,
    y: 787.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.18,
    y: 787.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.18,
    y: 787.618,
    width: 4,
    height: 6,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.3,
    y: 761.536,
    width: 30,
    height: 30,
    transform: "rotate(-179.899 1008.3 761.536)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.31 755.526L984.313 755.494L1002.34 737.526L1002.31 755.526Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.346 737.494L1002.35 737.526L984.314 755.494L984.346 737.494Z",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.303,
    y: 761.462,
    width: 30,
    height: 30,
    transform: "rotate(-179.899 966.303 761.462)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.312 755.452L942.313 755.42L960.344 737.452L960.312 755.452Z",
    fill: "#DFD4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.346 737.42L960.346 737.452L942.314 755.42L942.346 737.42Z",
    fill: "#868A93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.301,
    y: 762.387,
    width: 96,
    height: 31,
    transform: "rotate(-179.899 923.301 762.387)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.318,
    cy: 752.362,
    r: 4,
    transform: "rotate(-179.899 909.318 752.362)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.341,
    cy: 739.362,
    r: 4,
    transform: "rotate(-179.899 909.341 739.362)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892.318,
    cy: 752.332,
    r: 4,
    transform: "rotate(-179.899 892.318 752.332)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 892.341,
    cy: 739.332,
    r: 4,
    transform: "rotate(-179.899 892.341 739.332)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.318,
    cy: 752.302,
    r: 4,
    transform: "rotate(-179.899 875.318 752.302)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.341,
    cy: 739.302,
    r: 4,
    transform: "rotate(-179.899 875.341 739.302)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858.318,
    cy: 752.272,
    r: 4,
    transform: "rotate(-179.899 858.318 752.272)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858.341,
    cy: 739.272,
    r: 4,
    transform: "rotate(-179.899 858.341 739.272)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.318,
    cy: 752.242,
    r: 4,
    transform: "rotate(-179.899 841.318 752.242)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 841.341,
    cy: 739.242,
    r: 4,
    transform: "rotate(-179.899 841.341 739.242)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 772.443,
    y: 520.157,
    width: 35,
    height: 323,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.443,
    y: 491.157,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.443,
    y: 843.158,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800.443,
    y: 491.157,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800.443,
    y: 843.158,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 807.443,
    y: 520.157,
    width: 7,
    height: 323,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 545.157,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 580.157,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 615.157,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 650.157,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 685.157,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 720.157,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 755.158,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 783.443,
    y: 790.158,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.445,
    y: 520.06,
    width: 35,
    height: 323,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 723.445,
    y: 491.06,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 723.445,
    y: 843.061,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.445,
    y: 491.06,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.445,
    y: 843.061,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.445,
    y: 520.06,
    width: 7,
    height: 323,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 545.06,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 580.06,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 615.06,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 650.06,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 685.06,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 720.06,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 755.061,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 728.445,
    y: 790.061,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.445,
    y: 519.967,
    width: 35,
    height: 323,
    fill: "#FEC627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.445,
    y: 490.967,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.445,
    y: 842.967,
    width: 22,
    height: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.445,
    y: 490.967,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.445,
    y: 842.967,
    width: 7,
    height: 29,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.445,
    y: 519.967,
    width: 7,
    height: 323,
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 544.967,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 579.967,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 614.967,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 649.966,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 684.966,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 719.966,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 754.967,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.445,
    y: 789.967,
    width: 13,
    height: 27,
    fill: "#D8982A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 914.555,
    y: 618.371,
    width: 71,
    height: 68,
    transform: "rotate(-179.899 914.555 618.371)",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.38 714.536L949.385 714.433L949.414 697.933L935.438 684.408L949.505 646.433L977.498 650.482L994.026 634.511L1008.53 634.537L1008.38 714.536Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 914.516,
    y: 640.371,
    width: 71,
    height: 18,
    transform: "rotate(-179.899 914.516 640.371)",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 935.676,
    y: 549.408,
    width: 71,
    height: 18,
    transform: "rotate(90.101 935.676 549.408)",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.53 629.537L992.534 629.508L981.014 640.988L937.534 629.411L937.562 613.412L981.039 626.488L993.562 613.51L1008.56 613.537L1008.53 629.537Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.385 714.425L928.385 714.395L928.412 698.896L918.432 687.878L934.431 687.906L945.409 700.425L945.385 714.425Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.885 714.388L843.385 714.246L843.507 644.746L874.007 644.8L890.469 666.329L923.909 700.388L923.885 714.388Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.57 608.037L992.573 608.008L975.541 625.978L939.554 618.415L939.674 550.415L1008.67 550.537L1008.57 608.037Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 982.428,
    y: 690.491,
    width: 112,
    height: 118,
    transform: "rotate(-179.899 982.428 690.491)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.475,
    y: 663.438,
    width: 53,
    height: 64,
    transform: "rotate(-179.899 952.475 663.438)",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.484 657.427L906.484 657.357L946.574 606.427L946.484 657.427Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.576 606.357L946.576 606.427L906.486 657.357L906.576 606.357Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.62,
    cy: 580.454,
    r: 4,
    transform: "rotate(-179.899 961.62 580.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.62,
    cy: 580.479,
    r: 4,
    transform: "rotate(-179.899 975.62 580.479)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.601,
    cy: 591.454,
    r: 4,
    transform: "rotate(-179.899 961.601 591.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.601,
    cy: 591.479,
    r: 4,
    transform: "rotate(-179.899 975.601 591.479)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.583,
    cy: 602.454,
    r: 4,
    transform: "rotate(-179.899 961.583 602.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.583,
    cy: 602.479,
    r: 4,
    transform: "rotate(-179.899 975.583 602.479)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.564,
    cy: 613.454,
    r: 4,
    transform: "rotate(-179.899 961.564 613.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.564,
    cy: 613.479,
    r: 4,
    transform: "rotate(-179.899 975.564 613.479)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.54,
    cy: 626.454,
    r: 4,
    transform: "rotate(-179.899 961.54 626.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.54,
    cy: 626.478,
    r: 4,
    transform: "rotate(-179.899 975.54 626.478)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.521,
    cy: 637.454,
    r: 4,
    transform: "rotate(-179.899 961.521 637.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.521,
    cy: 637.478,
    r: 4,
    transform: "rotate(-179.899 975.521 637.478)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.499,
    cy: 649.454,
    r: 4,
    transform: "rotate(-179.899 961.499 649.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.499,
    cy: 649.478,
    r: 4,
    transform: "rotate(-179.899 975.499 649.478)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.48,
    cy: 660.454,
    r: 4,
    transform: "rotate(-179.899 961.48 660.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.48,
    cy: 660.478,
    r: 4,
    transform: "rotate(-179.899 975.48 660.478)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.458,
    cy: 672.454,
    r: 4,
    transform: "rotate(-179.899 961.458 672.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.458,
    cy: 672.478,
    r: 4,
    transform: "rotate(-179.899 975.458 672.478)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.439,
    cy: 683.454,
    r: 4,
    transform: "rotate(-179.899 961.439 683.454)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.439,
    cy: 683.478,
    r: 4,
    transform: "rotate(-179.899 975.439 683.478)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 932.458,
    cy: 672.403,
    r: 4,
    transform: "rotate(-179.899 932.458 672.403)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.458,
    cy: 672.427,
    r: 4,
    transform: "rotate(-179.899 946.458 672.427)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 932.439,
    cy: 683.403,
    r: 4,
    transform: "rotate(-179.899 932.439 683.403)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.439,
    cy: 683.427,
    r: 4,
    transform: "rotate(-179.899 946.439 683.427)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904.458,
    cy: 672.353,
    r: 4,
    transform: "rotate(-179.899 904.458 672.353)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.458,
    cy: 672.378,
    r: 4,
    transform: "rotate(-179.899 918.458 672.378)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 904.441,
    cy: 683.353,
    r: 4,
    transform: "rotate(-179.899 904.441 683.353)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.441,
    cy: 683.378,
    r: 4,
    transform: "rotate(-179.899 918.441 683.378)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.458,
    cy: 672.306,
    r: 4,
    transform: "rotate(-179.899 877.458 672.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.458,
    cy: 672.33,
    r: 4,
    transform: "rotate(-179.899 891.458 672.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.441,
    cy: 683.306,
    r: 4,
    transform: "rotate(-179.899 877.441 683.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.441,
    cy: 683.33,
    r: 4,
    transform: "rotate(-179.899 891.441 683.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.499,
    cy: 649.306,
    r: 4,
    transform: "rotate(-179.899 877.499 649.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.499,
    cy: 649.33,
    r: 4,
    transform: "rotate(-179.899 891.499 649.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.48,
    cy: 660.306,
    r: 4,
    transform: "rotate(-179.899 877.48 660.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.48,
    cy: 660.33,
    r: 4,
    transform: "rotate(-179.899 891.48 660.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.54,
    cy: 626.306,
    r: 4,
    transform: "rotate(-179.899 877.54 626.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.54,
    cy: 626.33,
    r: 4,
    transform: "rotate(-179.899 891.54 626.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.521,
    cy: 637.306,
    r: 4,
    transform: "rotate(-179.899 877.521 637.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.521,
    cy: 637.33,
    r: 4,
    transform: "rotate(-179.899 891.521 637.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.581,
    cy: 603.306,
    r: 4,
    transform: "rotate(-179.899 877.581 603.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.581,
    cy: 603.33,
    r: 4,
    transform: "rotate(-179.899 891.581 603.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.562,
    cy: 614.306,
    r: 4,
    transform: "rotate(-179.899 877.562 614.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.562,
    cy: 614.33,
    r: 4,
    transform: "rotate(-179.899 891.562 614.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.62,
    cy: 580.306,
    r: 4,
    transform: "rotate(-179.899 877.62 580.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.62,
    cy: 580.331,
    r: 4,
    transform: "rotate(-179.899 891.62 580.331)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.603,
    cy: 591.306,
    r: 4,
    transform: "rotate(-179.899 877.603 591.306)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.603,
    cy: 591.33,
    r: 4,
    transform: "rotate(-179.899 891.603 591.33)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.62,
    cy: 580.355,
    r: 4,
    transform: "rotate(-179.899 905.62 580.355)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.62,
    cy: 580.38,
    r: 4,
    transform: "rotate(-179.899 919.62 580.38)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.603,
    cy: 591.355,
    r: 4,
    transform: "rotate(-179.899 905.603 591.355)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919.603,
    cy: 591.38,
    r: 4,
    transform: "rotate(-179.899 919.603 591.38)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 933.62,
    cy: 580.405,
    r: 4,
    transform: "rotate(-179.899 933.62 580.405)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.62,
    cy: 580.429,
    r: 4,
    transform: "rotate(-179.899 947.62 580.429)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 933.603,
    cy: 591.404,
    r: 4,
    transform: "rotate(-179.899 933.603 591.404)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.603,
    cy: 591.429,
    r: 4,
    transform: "rotate(-179.899 947.603 591.429)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.643,
    cy: 567.514,
    r: 7,
    transform: "rotate(-179.899 995.643 567.514)",
    fill: "#41BA8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 995.417,
    cy: 696.514,
    r: 7,
    transform: "rotate(-179.899 995.417 696.514)",
    fill: "#41BA8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855.645,
    cy: 567.267,
    r: 7,
    transform: "rotate(-179.899 855.645 567.267)",
    fill: "#41BA8F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.396,
    y: 707.277,
    width: 6,
    height: 6,
    transform: "rotate(-179.899 861.396 707.277)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.396,
    y: 707.263,
    width: 6,
    height: 6,
    transform: "rotate(-179.899 853.396 707.263)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.416,
    y: 696.277,
    width: 6,
    height: 6,
    transform: "rotate(-179.899 861.416 696.277)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.416,
    y: 696.263,
    width: 6,
    height: 6,
    transform: "rotate(-179.899 853.416 696.263)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.436,
    y: 685.277,
    width: 6,
    height: 6,
    transform: "rotate(-179.899 861.436 685.277)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.436,
    y: 685.263,
    width: 6,
    height: 6,
    transform: "rotate(-179.899 853.436 685.263)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1483,
    y: 23.9794,
    width: 318,
    height: 31,
    transform: "rotate(-90 1483 23.9794)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492,
    y: 23.9794,
    width: 318,
    height: 12,
    transform: "rotate(-90 1492 23.9794)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492,
    y: 45.9794,
    width: 22,
    height: 12,
    transform: "rotate(-90 1492 45.9794)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432,
    y: 23.9783,
    width: 318,
    height: 31,
    transform: "rotate(-90 1432 23.9783)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1441,
    y: 23.9783,
    width: 318,
    height: 12,
    transform: "rotate(-90 1441 23.9783)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1441,
    y: 45.9783,
    width: 22,
    height: 12,
    transform: "rotate(-90 1441 45.9783)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1485,
    y: 648.979,
    width: 318,
    height: 31,
    transform: "rotate(-90 1485 648.979)",
    fill: "#FEC629"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494,
    y: 648.979,
    width: 318,
    height: 12,
    transform: "rotate(-90 1494 648.979)",
    fill: "#D89928"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494,
    y: 670.979,
    width: 22,
    height: 12,
    transform: "rotate(-90 1494 670.979)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494,
    y: 331,
    width: 22,
    height: 12,
    transform: "rotate(-90 1494 331)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1434,
    y: 648.978,
    width: 318,
    height: 31,
    transform: "rotate(-90 1434 648.978)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 648.978,
    width: 318,
    height: 12,
    transform: "rotate(-90 1443 648.978)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 670.978,
    width: 22,
    height: 12,
    transform: "rotate(-90 1443 670.978)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1443,
    y: 331,
    width: 22,
    height: 12,
    transform: "rotate(-90 1443 331)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 283H111V437.5L-1.5 548L-5 542L103 434V283Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 283H86V427.5L-26.5 538L-30 532L78 424V283Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147 612H1139V457.5L1245.5 353V197.5H1255V355.5L1147 461V612Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.86 612H1163V467.5L1273.56 357V301.5L1384 244.5V252L1282.5 305.5V357L1170.86 471V612Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 742L-2.5 703V693.5L44.5 739V857L85.5 898.5H76L36.5 860V742Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 763.5L-24 724.5V715L23 760.5V878.5L64 920H54.5L15 881.5V763.5Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.5 19.5L1188.5 -19.5V-29L1235.5 16.5V134.5L1267 167V176L1227.5 137.5V19.5Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206 41L1167 2V-7.5L1214 38V156L1255 197.5H1245.5L1206 159V41Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 -1H611V372L641 404V411L604 372V-1Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652 465H645L645 838L601 910.5V917.5L652 838L652 465Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 762H614L621 798L552.5 902.5H544.5L613 798L607 762Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 132H636L629 95.5L697.5 -9H705.5L637 95.5L643 132Z",
    fill: "#1E8C65"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1295,
    y: 191,
    width: 8,
    height: 25,
    fill: "#1E8C65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.c54cf26f341af3f1aef80e65df42cdc5.svg";
export { ForwardRef as ReactComponent };